import type { ClientAnalyticsEvent } from "../shared/analytics";

const SESSION_KEY = "sehrin-sesi.analytics-session.v1";

export function analyticsSessionId() {
  const existing = window.sessionStorage.getItem(SESSION_KEY);
  if (existing) return existing;
  const created = crypto.randomUUID();
  window.sessionStorage.setItem(SESSION_KEY, created);
  return created;
}

export function trackClientEvent(
  eventName: ClientAnalyticsEvent["eventName"],
  details: Omit<ClientAnalyticsEvent, "eventName" | "anonymousSessionId"> = {}
) {
  const body: ClientAnalyticsEvent = {
    eventName,
    anonymousSessionId: analyticsSessionId(),
    ...details
  };
  void fetch("/api/analytics/events", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
    keepalive: true
  }).catch(() => undefined);
}
